export const LETTERS_SIZE_TO_CONTAINER_SIZE_RATE = 0.416;
export const PLUS_ICON_SIZE_TO_CONTAINER_SIZE = 0.02;
export const PLUS_ICON_SIZE_DEFAULT = 3;
